import React, { PropsWithChildren } from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import {
  theme,
  IconInformation,
  IconStats
} from '@contrast-security-inc/design-system-foundations'
import {
  InformationPanel,
  InformationPanelProps
} from '@contrast-security-inc/design-system-surfaces'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { Text } from '@contrast-security-inc/design-system-typography'

export const Wrapper = (props: PropsWithChildren<InformationPanelProps>) => {
  return (
    <Stack>
      <InformationPanel
        className={css`
          width: 100%;
          height: fit-content;
          background-color: ${theme.color.neutral10};
          border: solid 1px ${theme.color.neutral40};
          margin-left: 30px;
          margin-right: 30px;
          line-height: 24px;
        `}
        {...props}
      />
    </Stack>
  )
}

export const AppActivityEmptyStateUnlicensed = () => {
  const intl = useIntl()

  return (
    <Wrapper
      testId="app-activity-empty-state"
      Icon={IconInformation}
      title={intl.formatMessage({
        id: 'detail_applicationFeatures_urlActivity_unavailable'
      })}
      subtitle={intl.formatMessage(
        { id: 'detail_applicationFeatures_unlicensedApp_activity' },
        { div: (msg) => <div>{msg}</div> }
      )}
    />
  )
}

export const RouteCoverageEmptyStateUnlicensed = () => {
  const intl = useIntl()

  return (
    <Wrapper
      testId="route-coverage-empty-state"
      Icon={IconInformation}
      title={intl.formatMessage({
        id: 'detail_applicationFeatures_youCanGetMore'
      })}
      subtitle={intl.formatMessage({
        id: 'detail_applicationFeatures_unlicensedApp'
      })}
      detail={intl.formatMessage({
        id: 'detail_applicationRouteCoverage_routeCoverageDescription'
      })}
    >
      <Text>
        {intl.formatMessage({
          id: 'detail_applicationFeatures_applyLicenseToGetFeatures'
        })}
      </Text>
    </Wrapper>
  )
}

export const RouteCoverageEmptyStateNoRoutes = () => {
  const intl = useIntl()

  return (
    <Wrapper
      Icon={IconStats}
      title={intl.formatMessage({
        id: 'title_applicationCoverage_noRoutes'
      })}
      subtitle={intl.formatMessage(
        {
          id: 'detail_applicationCoverage_supportedFrameworks'
        },
        {
          a: (...msg) => (
            <a
              href="https://docs.contrastsecurity.com/en/route-coverage.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              {msg}
            </a>
          )
        }
      )}
      detail={intl.formatMessage({
        id: 'detail_applicationCoverage_resetToDiscover'
      })}
      testId="route-coverage-no-routes"
    >
      <Text>
        {intl.formatMessage({
          id: 'detail_applicationCoverage_browseApp'
        })}
      </Text>
    </Wrapper>
  )
}
